export default "__VITE_ASSET__09940fbf__"